export default {
      id: "ic_plus_famille-usage",
      viewBox: "0 0 30 30",
      url: "../dist/images/" + "sprite.svg#ic_plus_famille-usage",
      toString: function () {
        return this.url;
      }
    }